'use strict';
require('./typeahead');
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.searchWidget = function (mapModel) {
	const self = this,
		findNode = function (str) {
			return mapModel.search(str);
		},
		focusNode = function (node) {
			if (node && node.id) {
				self.addClass('hidden');
				mapModel.centerOnNode(node.id);
			}
		},
		formatTitle = function (domEl, node, currentVal) {
			const title = node.title,
				initFormatted = title.replace(/\n/g, ' '),
				index = initFormatted.toLowerCase().indexOf(currentVal.toLowerCase());
			let formatted = initFormatted;
			if (index > 15) {
				formatted = formatted.substring(0, 15) + '...' + formatted.substring(index);
			}
			if (formatted.length > 30) {
				formatted = formatted.substring(0, 30) + '...';
			}
			domEl.text(formatted);
		};
	return this.typeahead(findNode, focusNode, formatTitle);
};
